import {createStore, applyMiddleware } from "redux"
import {createLogger} from "redux-logger"
import thunk from "redux-thunk"
import promiseMiddleware from "redux-promise-middleware"

import reducers from "./reducers"

const middleware = applyMiddleware(promiseMiddleware(), thunk, createLogger())

export default createStore(reducers, middleware)